
/**
 * Yes or No
 *
 * Note: that array values positions are used to validate if 'yes' has been chose
 */
const yesNo = ['כן', 'לא']

/**
 * Export
 */
export { yesNo }
